import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-petrol" data-id="element-202" data-mp="1o2vfqkp72f4g">
      <div className="max-w-4xl mx-auto text-center" data-id="element-203" data-mp="223eltma3nb3z">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-204" data-mp="2223g3gx3fta8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/20 text-gold mb-6 border border-gold/30" data-id="element-205" data-mp="14fo42unfrnu2">
            <ShieldCheck size={40} data-id="element-206" data-mp="1j5lsnbpa2fjs" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-8" data-id="element-207" data-mp="1edu2v3dy4dup">
            Garantía total de 7 días
          </h2>

          <div className="space-y-6 text-lg text-cream-light max-w-2xl mx-auto font-medium" data-id="element-208" data-mp="qn7u19w4apjn">
            <p data-id="element-209" data-mp="lpy6jzsagnyg">
              Abrí los 5 tomos. Revisá los 5 bonos. Usalos en tu práctica de
              taller.
            </p>
            <p data-id="element-210" data-mp="oz03bv02a0ob">
              Si dentro de los primeros 7 días considerás que el material no
              cumple con lo que prometemos, te devolvemos el 100% de tu dinero.
            </p>
            <p className="text-gold" data-id="element-211" data-mp="yqmbfih3rjmu">
              Sin formularios complicados. Sin preguntas incómodas. Sin demoras.
            </p>
            <p className="text-base font-normal opacity-90" data-id="element-212" data-mp="12sr52h7jwg9h">
              El proceso es simple: contacto, solicitud, devolución completa en
              24 a 48 horas hábiles.
            </p>
            <p className="text-sm font-normal opacity-80 mt-8" data-id="element-213" data-mp="b1utrl152job">
              Porque si el material no te da el valor que prometemos, no tiene
              sentido que te quedés con él ni nosotros con tu dinero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}